/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var AttachPaperclipIcon20Regular = forwardRef('AttachPaperclipIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M12.12 3.83a3.64 3.64 0 1 1 5.147 5.148l-6.871 6.871a5.085 5.085 0 0 1-7.191-7.191l4.807-4.807a.75.75 0 0 1 1.06 1.06L4.266 9.72a3.585 3.585 0 0 0 5.07 5.07l6.872-6.872a2.14 2.14 0 0 0-3.027-3.026l-6.86 6.86a.695.695 0 0 0 .982.984l4.797-4.797a.75.75 0 0 1 1.06 1.06l-4.796 4.798a2.195 2.195 0 1 1-3.105-3.105L12.12 3.83Z" })));
});
